import { createAction } from '@reduxjs/toolkit'

import type {
  TGetCompaniesResponse,
  TUpdateCompanyResponse
} from '@homepal/api-contract'

// tryGetAllCompanies
export const getAll = createAction('get_all_companies')
export const getAllSuccess = createAction<TGetCompaniesResponse>(
  'get_all_companies_success'
)
export const getAllFailed = createAction('get_all_companies_failed')

// tryUpdateCompany
export const update = createAction('update_company')
export const updateSuccess = createAction<TUpdateCompanyResponse>(
  'update_company_success'
)
export const updateFailed = createAction('update_company_failed')
